import { render, staticRenderFns } from "./producto_crud_informacion.vue?vue&type=template&id=64ea35c8"
import script from "./producto_crud_informacion.vue?vue&type=script&lang=js"
export * from "./producto_crud_informacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports